import React, { forwardRef } from 'react';

export const NumberInputField = forwardRef(
  (
    {
      placeholder,
      label,
      error,
      extraClasses = '',
      height = '36',
      minChar,
      maxChar,
      disabled = false,
      preventKeys = ['e', '+', '-'],
      ...rest
    },
    ref,
  ) => {
    const text = error || label || '';

    return (
      <div className="w--full  d--flex flex--column">
        {text && (
          <label
            className={`label--control font--sm font--500 m-b--sm  ${
              error ? 'text--danger' : 'text--black'
            }`}
          >
            {text}
          </label>
        )}
        <input
          inputMode="numeric"
          type={'number'}
          {...rest}
          ref={ref}
          min={rest?.min ?? 0}
          max={rest?.max ?? 999999999999999}
          placeholder={placeholder}
          className={`form--control w--full h-min--${height}  radius--sm p-l--md p-r--md ${extraClasses} ${error ? 'border-full--danger' : 'border-full--black-200'}`}
          onChange={(e) => {
            if (maxChar && e.target.value.toString().length > maxChar) {
              e.preventDefault();
              return;
            } else {
              rest?.onChange(e);
            }
          }}
          onKeyDown={(e) => {
            if (preventKeys.includes(e.key)) e.preventDefault();
          }}
          disabled = {disabled}
        />
      </div>
    );
  },
);
